var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1580975612081,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2183,
    width: 14,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M931.968 960 156.032 960C140.608 960 128 947.392 128 931.968L128 92.032C128 76.608 140.608 64 159.168 64l610.368 0L960 256l0 675.968C960 947.392 947.392 960 931.968 960zM768 128l0 128 128 0L768 128zM896 320l-190.464 0L705.536 128 192 128l0 768 704 0L896 320zM640 288C640 270.336 625.664 256 608 256l-320 0C270.336 256 256 270.336 256 288l0 0C256 305.664 270.336 320 288 320l320 0C625.664 320 640 305.664 640 288L640 288zM832 416C832 398.336 817.664 384 800 384l-512 0C270.336 384 256 398.336 256 416l0 0C256 433.664 270.336 448 288 448l512 0C817.664 448 832 433.664 832 416L832 416zM832 544C832 526.336 817.664 512 800 512l-512 0C270.336 512 256 526.336 256 544l0 0C256 561.664 270.336 576 288 576l512 0C817.664 576 832 561.664 832 544L832 544zM832 672c0-17.664-14.336-32-32-32l-512 0C270.336 640 256 654.336 256 672l0 0C256 689.664 270.336 704 288 704l512 0C817.664 704 832 689.664 832 672L832 672z",
    "p-id": 2184,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentation);
export default __webpack_public_path__ + "static/media/documentation.dbc2d128b42817288da20ac214664dc6.svg";
export { ForwardRef as ReactComponent };